<template>
    <v-flex xs12>
        <canvas id="device" height="400" style="width: 100%"></canvas>
    </v-flex>
</template>

<script>
    import Chart from 'chart.js'

    export default {
        name: 'deviceCustomer',
        props: ['dataDevice'],
        mounted () {
            let ctx = document.getElementById('device').getContext('2d')

            new Chart(ctx, {
                type: 'doughnut',
                data: {
                    labels: ['iOS', 'Android', 'Telegram'],
                    datasets: [
                        {
                            data: [
                                this.dataDevice.ios,
                                this.dataDevice.android,
                                this.dataDevice.telegram,
                            ],
                            backgroundColor: [
                                '#D0021B',
                                '#3DDC84',
                                '#0088cc',
                            ],
                        }
                    ]
                },
                options: {
                    responsive: true,
                    legend: {
                        position: 'right',
                    },
                    title: {
                        display: true,
                        text: `Общее количество с платформ - ${this.dataDevice.all_devices + this.dataDevice.telegram}`
                    }
                }
            })
        }
    }
</script>
